import { render, staticRenderFns } from "./create-product-form.vue?vue&type=template&id=5afa27d1&scoped=true&"
import script from "./create-product-form.ts?vue&type=script&lang=ts&"
export * from "./create-product-form.ts?vue&type=script&lang=ts&"
import style0 from "./create-product-form.scss?vue&type=style&index=0&id=5afa27d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa27d1",
  null
  
)

export default component.exports